import { Mode } from '@/common/entityFramework/enumerations/Mode';
import { Link, useTheme } from '@mui/material';
import { useNavState } from '../../navState/NavStateContext';
import { StringUtils } from '../../utils/StringUtils';

/**
 * Links a cell to an Entity named by the row rather than by the column, so a tree whose rows span
 * several Entities (e.g. Contract -> Program -> Program Product -> Tier) can navigate from any level.
 * colDef.linkEntityField/linkEntityIdField let two columns on one row target different Entities.
 */
export const EntityLinkCellRenderer = ({ data, value, colDef }) => {
  const { navigateTo } = useNavState();
  const theme = useTheme();

  const entity = data?.[colDef.linkEntityField ?? 'linkEntity'];
  const entityId = data?.[colDef.linkEntityIdField ?? 'linkEntityId'];

  const navigate = (openNewTab) => {
    const route = colDef.module + '/' + StringUtils.toKebabConvention(entity);
    navigateTo(route, { entityId: entityId, mode: Mode.DETAIL }, openNewTab);
  };

  // Grouping and attribute rows are not Entities, so there is nothing to navigate to
  if (!entity || !entityId) {
    return value;
  }

  return (
    <Link
      onClick={(event) => navigate(event.ctrlKey)}
      sx={{
        cursor: 'pointer',
        color: theme.palette.primary.dark,
      }}
    >
      {value}
    </Link>
  );
};
